<script lang="ts">
	import { userClientData } from '../../stores';
</script>

<div
	style={`--range-handle-inactive: ${$userClientData.webData.primaryColor};--range-handle: ${$userClientData.webData.primaryColor};--range-handle-focus: ${$userClientData.webData.primaryColor};--mdc-theme-primary: ${$userClientData.webData.primaryColor};--mdc-theme-secondary: ${$userClientData.webData.secondaryColor}`}
>
	<slot />
</div>

<style>
	div {
		height: 100%;
	}
</style>
